import React, { Component } from 'react'
import { connect } from 'react-redux'

import * as loadingActions from '../../state/actions/loading'

import Config from '../../config/Config.json'
import Config_local from '../../config/Config_local.json'
import NewsQueryConfig from './NewsQueryConfig.json'
import NewsListItem from "./NewsListItem"


const config = {...Config, ...Config_local}

const newsTileWidth = () => {
	if(typeof window !== 'undefined'){
		switch(true){
			case window.innerWidth <  1200:
				return 2
			case window.innerWidth <  768:
				return 1
			default:
				return 4
		}
	}
	return 0
}

class NewsList extends Component {
	_isMounted = false

	constructor(props, context) {
		super(props, context)

		//On définit les variables à surveiller
		this.state = {
			totals: false,
			page: 0,
			launchNews: true,
			posts: 0,
			currentPosition: 0,
			nbrSlide: newsTileWidth(),
			changeArrow: false
		}
	}

	componentDidMount(){
		this._isMounted = true
		const {loadingOn, where} = this.props
		
		where === 'home' && typeof window !== 'undefined' && window.addEventListener('resize', this.newsUpdateWindowsWidth)
		this.launchNews()
		loadingOn('NewsHome')
	}

	componentWillUnmount() {
		const {loadingOff, where} = this.props

		where === "home" && typeof window !== 'undefined' && window.removeEventListener('resize', this.newsUpdateWindowsWidth)
		loadingOff('NewsHome')
		this._isMounted = false
	}

	newsUpdateWindowsWidth = () => {
		this.setState({nbrSlide: newsTileWidth()})
	}

	launchNews() {
		const {loadingOff} = this.props
		const body = JSON.stringify(NewsQueryConfig.queryDefault)

		fetch(config.esServer,
			{
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
					tokenesinouit: 'spS4brB5EYX2tu8exUPFZDXvAr0ZD7u9whzxPfGqGvGWGcRMDqHxH04axVSj1k0a6TlJTAagi4Sz3yKg5NNPi0F7m2LUSFvZCCQYzMdTS3WXxAXtATBbWVhXwMpSS79PycfnwdabDVsSWttOAWkyCK67DWXq5g1HYTwH8toyF9HyZwrOmttRnYQSf4qnzUJJWYyTAAbvBrdegXFweIdt5IRX0S5GL8ARk3Kz30GWR3tQpxNwrmid9nSe7SQxopoVC7Kl9gR5zQY7ijpeohaEqJZsvg3hN400000iGm8nKB0vKL2i9nPFaLIzVXV6c4RKuWBwzXrBOiCfyAtjyZAe7dpEIuqz82cIh80wiRaVCdOQ9YtE355IqgpiOytsSKTtw6HuWaGjopqjRe9pzixWJWGhLRGPB9iZRe1TP78HuiPdWKHUGWxB5MHroMoTbFqfyLXo9kk4djQA2GuAsTLI8VYOCDwCAcfJOPMtJIwa356KHK8Ma4VCFYgWqJ2sZtT77pOszI8deVGb9M1DXWD9nPhsGJSqDt4K8TRzhcVmgn8sUamx8TFyPa1E06Gh2QUCyXTfjOP0LzSgAdb2gaOohuSOfYibjfoE3aCSnevQAflmGoCqsFphlYNCTzYQhdO2'
				},
				method: "POST",
				body
			}
		).then(response => {
			if(response.status && response.status > 200 ){
				console.warn('Erreur lors du chargement des actualités:', response)
				// Gestion d'erreur accessible
				this._isMounted && this.setState({
					posts: [],
					totals: 0
				})
			}else{
				return response.json()
			}
		}).then(results => {
			if (results && results.hits) {
				const {total, hits} = results.hits
				this._isMounted && this.setState({
					totals: total || 0,
					posts: hits || []
				})
			} else {
				// Gestion des résultats invalides
				this._isMounted && this.setState({
					posts: [],
					totals: 0
				})
			}

			loadingOff('NewsHome')
		}).catch((error) => {
			console.error("Erreur lors du chargement des actualités:", error)
			// Gestion d'erreur accessible
			this._isMounted && this.setState({
				posts: [],
				totals: 0
			})
			loadingOff('NewsHome')
		})
	}

	newsSlidePrev = (e) => {
		e.preventDefault()
		const {currentPosition, nbrSlide, totals} = this.state

		// Calcul de la nouvelle position avec gestion des limites
		const newPosition = Math.max(0, currentPosition - 1)
		
		this.setState({
			currentPosition: newPosition,
			changeArrow: false
		})

		// Annoncer le changement de page pour les lecteurs d'écran
		if (this._isMounted) {
			const currentPage = Math.floor(newPosition / nbrSlide) + 1
			const totalPages = Math.ceil(totals / nbrSlide)
			// L'aria-live="polite" sur la section annoncera automatiquement le changement
		}
	}

	newsSlideNext = (e) => {
		e.preventDefault()
		const {currentPosition, nbrSlide, totals} = this.state
		
		// Calcul de la nouvelle position avec gestion des limites
		const maxPosition = Math.max(0, Math.ceil(totals / nbrSlide) - 1)
		const newPosition = Math.min(maxPosition, currentPosition + 1)
		const nextPosition = Math.min(maxPosition, currentPosition + 2)

		this.setState({
			currentPosition: newPosition,
			changeArrow: (newPosition > 0 && nextPosition === 0)
		})

		// Annoncer le changement de page pour les lecteurs d'écran
		if (this._isMounted) {
			const currentPage = Math.floor(newPosition / nbrSlide) + 1
			const totalPages = Math.ceil(totals / nbrSlide)
			// L'aria-live="polite" sur la section annoncera automatiquement le changement
		}
	}

	render(){
		const {posts, currentPosition, nbrSlide, totals} = this.state
		const {where} = this.props

		// Validation des props
		if (!posts || !Array.isArray(posts)) {
			return (
				<section role="region" aria-label="Liste des actualités" className="news-list-error">
					<p className="visually-hidden">Erreur de chargement des actualités</p>
				</section>
			)
		}

		const hasPosts = posts.length > 0
		const currentPage = Math.floor(currentPosition / nbrSlide) + 1
		const totalPages = Math.ceil(totals / nbrSlide)
		const sectionTitle = where ? `Actualités - ${where}` : 'Liste des actualités'

		return (
			<section 
				id="news-list" 
				role="region" 
				aria-label={sectionTitle}
				aria-live="polite"
				className={where ? `news-list-${where}` : 'news-list'}
			>
				{where && hasPosts && (
					<button 
						className="news-list-home-prev" 
						onClick={this.newsSlidePrev} 
						onKeyPress={this.newsSlidePrev}
						aria-label={`Actualité précédente - Page ${currentPage > 1 ? currentPage - 1 : totalPages}`}
						aria-controls="news-list"
						disabled={currentPosition === 0}
					>
						<span className="visually-hidden">Précédent</span>
					</button>
				)}
				
				<div className="news-list-container" aria-label="Contenu des actualités">
					<ul 
						className="news-list list-unstyled" 
						role="list"
						aria-label={`Liste des actualités - Page ${currentPage} sur ${totalPages}`}
						style={{transform: `translate3d(-${300 * currentPosition * nbrSlide}px, 0, 0)`}}
					>
						{hasPosts ? (
							this.state.posts.map((post, index) =>
								<li 
									className="news-list-item news-list-home-item" 
									key={index}
									role="listitem"
									aria-label={`Actualité ${index + 1}`}
								>
									<NewsListItem
										postIndex={index}
										postItem={post}
									/>
								</li>
							)
						) : (
							<li className="news-list-empty" role="listitem">
								<p className="visually-hidden">Aucune actualité disponible</p>
							</li>
						)}
					</ul>
				</div>

				{where && hasPosts && (
					<button 
						className={`news-list-home-next ${this.state.changeArrow ? "news-list-home-next-gostart" : ""}`}
						onClick={this.newsSlideNext} 
						onKeyPress={this.newsSlideNext}
						aria-label={`Actualité suivante - Page ${currentPage < totalPages ? currentPage + 1 : 1}`}
						aria-controls="news-list"
						disabled={this.state.changeArrow}
					>
						<span className="visually-hidden">Suivant</span>
					</button>
				)}

				{hasPosts && (
					<div className="news-list-pagination" role="status" aria-live="polite">
						<span className="visually-hidden">
							Page {currentPage} sur {totalPages} - {totals} actualité{totals > 1 ? 's' : ''} au total
						</span>
					</div>
				)}
			</section>
		)
	}
}

export default connect(null, loadingActions)(NewsList)
